var map = {
	"./calendar-carousels": [
		64353,
		4486,
		9421,
		8546
	],
	"./calendar-carousels-v2": [
		51979,
		9421,
		7646
	],
	"./calendar-carousels-v2.js": [
		51979,
		9421,
		7646
	],
	"./calendar-carousels.js": [
		64353,
		4486,
		9421,
		8546
	],
	"./carousels": [
		50578,
		4486,
		9421,
		8848
	],
	"./carousels.js": [
		50578,
		4486,
		9421,
		8848
	],
	"./editorial-list-load-more": [
		70145,
		9147
	],
	"./editorial-list-load-more.js": [
		70145,
		9147
	],
	"./favorites-news": [
		23127,
		4486,
		2737,
		9421,
		3518
	],
	"./favorites-news.js": [
		23127,
		4486,
		2737,
		9421,
		3518
	],
	"./infinite-article": [
		88082,
		4486,
		9421,
		2322
	],
	"./infinite-article.js": [
		88082,
		4486,
		9421,
		2322
	],
	"./lang-dropdown": [
		92257,
		8022
	],
	"./lang-dropdown.js": [
		92257,
		8022
	],
	"./lazy-load-sample-module": [
		99039,
		7477
	],
	"./lazy-load-sample-module.js": [
		99039,
		7477
	],
	"./local-number": [
		46653,
		3993
	],
	"./local-number.js": [
		46653,
		3993
	],
	"./local-time": [
		88309,
		4486,
		5905
	],
	"./local-time.js": [
		88309,
		4486,
		5905
	],
	"./login-welcome-page": [
		36642,
		2737,
		7695
	],
	"./login-welcome-page.js": [
		36642,
		2737,
		7695
	],
	"./match-live-update": [
		17024,
		4486,
		682
	],
	"./match-live-update.js": [
		17024,
		4486,
		682
	],
	"./modal": [
		51863,
		2464
	],
	"./modal.js": [
		51863,
		2464
	],
	"./play-games-link": [
		64698,
		2737,
		6987
	],
	"./play-games-link.js": [
		64698,
		2737,
		6987
	],
	"./player-favorites": [
		61304,
		2737,
		6158
	],
	"./player-favorites.js": [
		61304,
		2737,
		6158
	],
	"./player-header": [
		8104,
		2737,
		6158,
		4717
	],
	"./player-header.js": [
		8104,
		2737,
		6158,
		4717
	],
	"./player-stats": [
		60853,
		6292
	],
	"./player-stats.js": [
		60853,
		6292
	],
	"./player-tournaments": [
		40046,
		4486,
		2803
	],
	"./player-tournaments.js": [
		40046,
		4486,
		2803
	],
	"./players-rankings-module": [
		12487,
		4486,
		2737,
		6158,
		1117
	],
	"./players-rankings-module.js": [
		12487,
		4486,
		2737,
		6158,
		1117
	],
	"./social-icons": [
		16639,
		7955
	],
	"./social-icons.js": [
		16639,
		7955
	],
	"./tournament-calendar": [
		81019,
		5693
	],
	"./tournament-calendar.js": [
		81019,
		5693
	],
	"./tournament-draws": [
		42886,
		4486,
		682,
		5763
	],
	"./tournament-draws.js": [
		42886,
		4486,
		682,
		5763
	],
	"./tournament-header": [
		15371,
		626
	],
	"./tournament-header-v2": [
		45589,
		9421,
		6326
	],
	"./tournament-header-v2.js": [
		45589,
		9421,
		6326
	],
	"./tournament-header.js": [
		15371,
		626
	],
	"./tournament-matches-list": [
		94050,
		4486,
		682,
		4442
	],
	"./tournament-matches-list.js": [
		94050,
		4486,
		682,
		4442
	],
	"./tournament-scores": [
		62492,
		4486,
		682,
		8808
	],
	"./tournament-scores-live": [
		55044,
		4840
	],
	"./tournament-scores-live.js": [
		55044,
		4840
	],
	"./tournament-scores-v2": [
		47757,
		4486,
		682,
		4608
	],
	"./tournament-scores-v2.js": [
		47757,
		4486,
		682,
		4608
	],
	"./tournament-scores.js": [
		62492,
		4486,
		682,
		8808
	],
	"./tournaments-list": [
		24271,
		2939
	],
	"./tournaments-list.js": [
		24271,
		2939
	],
	"./user-account": [
		7278,
		2737,
		6759
	],
	"./user-account.js": [
		7278,
		2737,
		6759
	],
	"./video-details-module": [
		84306,
		4486,
		3213
	],
	"./video-details-module.js": [
		84306,
		4486,
		3213
	],
	"./video-player": [
		291,
		8472
	],
	"./video-player-iframe": [
		88797,
		1719
	],
	"./video-player-iframe.js": [
		88797,
		1719
	],
	"./video-player.js": [
		291,
		8472
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 81335;
module.exports = webpackAsyncContext;